import commonService from "./commonService";
import utils from "./utils";
import axios from "axios";

const getAll = async () => {
  const url = utils.url + "/provinces";
  return await commonService.load(url, null, []);
};

const get = async (id) => {
  const url = `${utils.url}/provinces/${id}`;
  return await commonService.load(url);
};

export default { getAll, get };
